// Las acciones del historial de lugares de un agente, tal como las devuelve
// `rnhAgenteLugarHistAccion` en `rnhAgenteLugaresHistorial`.
//
// Son de SOLO LECTURA: el historial es un log, no algo que la app escriba.

export const ACCIONES_HISTORIAL = [
    { cod: "A", label: "Asignación" },
    { cod: "M", label: "Modificación" },
    { cod: "D", label: "Desasignación" },
];

/**
 * Código -> etiqueta legible. Si el código no está en la tabla devuelve el crudo: es
 * preferible ver una letra rara y darse cuenta de que falta una acción, a ver la celda
 * vacía y no enterarse. Mismo criterio que `etiquetaEstado`.
 */
export const labelDeAccion = (cod) =>
    ACCIONES_HISTORIAL.find((a) => a.cod === cod)?.label ?? (cod ?? "");
